import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

import TopSalesByService from '../containers/TopSalesByService';
import TopSalesByProduct from '../containers/TopSalesByProduct';
import TopSalesByBarber from '../containers/TopSalesByBarber';
import Leaderboard from '../containers/Leaderboard';
import BusinessProductivity from '../containers/BusinessProductivity';
import ServicesSold from '../containers/ServicesSold';
import ProductsSold from '../containers/ProductsSold';
import Layout from '../../components/Layout';
import DirtyFilterOverlay from '../../components/DirtyFilterOverlay';
import Filters from '../../filters/containers/Filters';

const Dashboard = ({ fetchDashboard }) => (
  <Layout title={t('reports:navigation.leaderboard')}>
    <Filters disableBarberFilter showCsvExport={false} fetcher={fetchDashboard} />
    <div className="c-dashboard-grid u-mt u-position-relative">
      <DirtyFilterOverlay />
      <div className="c-dashboard-grid__leaderboard">
        <Leaderboard />
      </div>
      <div className="c-dashboard-grid__productivity">
        <BusinessProductivity />
      </div>
      <div className="c-dashboard-grid__products">
        <ProductsSold />
      </div>
      <div className="c-dashboard-grid__services">
        <ServicesSold />
      </div>
      <div className="c-dashboard-grid__sales-by-service">
        <TopSalesByService />
      </div>
      <div className="c-dashboard-grid__sales-by-product">
        <TopSalesByProduct />
      </div>
      <div className="c-dashboard-grid__sales-by-barber">
        <TopSalesByBarber />
      </div>
    </div>
  </Layout>
);

Dashboard.propTypes = {
  fetchDashboard: PropTypes.func.isRequired,
};

export default Dashboard;
